import { showToast, showNotify, showDialog } from 'vant'
import { Base64 } from "js-base64";
import variables from '@/assets/styles/variables.less'
import i18n from '@/lang/index.js'
import cache from './cache'
export default {
	install: (app) => {
		app.config.globalProperties.$i18n = i18n
		app.config.globalProperties.$toast = showToast
		app.config.globalProperties.$notify = showNotify
		app.config.globalProperties.$dialog = showDialog
		app.config.globalProperties.$Base64 = Base64
		app.config.globalProperties.$cache = cache
		app.config.globalProperties.variablesStyles = variables
	}
}